export enum IntraDayProfileStreamElementType {
    Status = 101,
}
